<template>
  <v-container id="regular-tables" fluid tag="section">
    <base-v-component
      heading="Service Reports"
      link="components/simple-tables"
    />

    <base-material-card
      icon="mdi-clipboard-text"
      title="Service Reports"
      class="px-5 py-3"
    >
      <div class="d-flex justify-end">
        <v-col class="d-flex align-self-end" cols="12" sm="2">
          <v-select
            v-model="selectedType"
            :items="types"
            label="Department"
            item-text="name"
            item-value="value"
            outlined
            @change="changeSystem"
          />
        </v-col>
      </div>
      <h2 v-if="selectedType == 'finish-analytics' || selectedType == 'all'">
        Finish
      </h2>
      <div v-if="selectedType == 'finish-analytics' || selectedType == 'all'">
        <div class="row">
          <h4 class="my-5 pl-3 primary--text">Account Manager</h4>
        </div>

        <section class="row">
          <div
            v-for="(value, acctmgr) in finishServiceReports"
            :key="acctmgr"
            class="col-md-12"
          >
            <!--td>{{ customer.line }}</td-->
            <h3 v-if="acctmgr != ''">
              {{ acctmgr }}
            </h3>
            <table v-if="acctmgr != ''" style="width: 100%">
              <thead>
                <tr>
                  <th class="primary--text">
                    <p>Year</p>
                  </th>
                  <th class="primary--text">
                    <p>Month</p>
                  </th>
                  <th class="primary--text">
                    <p>Count</p>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(record, index) in value"
                  :key="index"
                  class="text-center"
                >
                  <td>{{ record.YR }}</td>
                  <td>{{ record.MNTH }}</td>
                  <td>{{ record.CNT }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>
      </div>

      <h2 v-if="selectedType == 'aqua-analytics' || selectedType == 'all'">
        Aqua
      </h2>
      <div v-if="selectedType == 'aqua-analytics' || selectedType == 'all'">
        <div class="row">
          <h4 class="my-5 pl-3 primary--text">Account Manager</h4>
        </div>

        <section class="row">
          <div
            v-for="(value, acctmgr) in aquaServiceReports"
            :key="acctmgr"
            class="col-md-12"
          >
            <h3 v-if="acctmgr != ''">
              {{ acctmgr }}
            </h3>
            <table v-if="acctmgr != ''" style="width: 100%">
              <thead>
                <tr>
                  <th class="primary--text">
                    <p>Year</p>
                  </th>
                  <th class="primary--text">
                    <p>Month</p>
                  </th>
                  <th class="primary--text">
                    <p>Count</p>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(record, index) in value"
                  :key="index"
                  class="text-center"
                >
                  <td>{{ record.YR }}</td>
                  <td>{{ record.MNTH }}</td>
                  <td>{{ record.CNT }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>
      </div>
      <h2 v-if="selectedType == 'metal-analytics' || selectedType == 'all'">
        Metal
      </h2>

      <div v-if="selectedType == 'metal-analytics' || selectedType == 'all'">
        <div class="row">
          <h4 class="my-5 pl-3 primary--text">Account Manager</h4>
        </div>
        <section class="row">
          <div
            v-for="(value, acctmgr) in metalServiceReports"
            :key="acctmgr"
            class="col-md-12"
          >
            <h3 v-if="acctmgr != ''">
              {{ acctmgr }}
            </h3>
            <table v-if="acctmgr != ''" style="width: 100%">
              <thead>
                <tr>
                  <th class="primary--text">
                    <p>Year</p>
                  </th>
                  <th class="primary--text">
                    <p>Month</p>
                  </th>
                  <th class="primary--text">
                    <p>Count</p>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(record, index) in value"
                  :key="index"
                  class="text-center"
                >
                  <td>{{ record.YR }}</td>
                  <td>{{ record.MNTH }}</td>
                  <td>{{ record.CNT }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>
      </div>
    </base-material-card>
  </v-container>
</template>

<script>
import Axios from "axios";
import { constants } from "../../../constants";

export default {
  name: "DashboardPagesTimeline",
  data: () => ({
    selectedType: "finish-analytics",
    types: [
      { name: "Finish", value: "finish-analytics" },
      { name: "Aqua", value: "aqua-analytics" },
      { name: "Metal", value: "metal-analytics" },
      { name: "All", value: "all" },
    ],
    menu: false,
    finishServiceReports: [],
    aquaServiceReports: [],
    metalServiceReports: [],
  }),
  created() {
    Axios.get(
      constants.VUE_APP_BASEURL + "/service-reports?type=finish-analytics"
    ).then((res) => {
      this.finishServiceReports = res.data.serviceReports.filter(
        (customer) => customer.line === "finish-analytics"
      );
      this.finishServiceReports = this.finishServiceReports.reduce(function (
        r,
        a
      ) {
        r[a.acctmgr] = r[a.acctmgr] || [];
        r[a.acctmgr].push(a);
        return r;
      },
      Object.create(null));
    });
  },
  methods: {
    changeSystem(a) {
      Axios.get(constants.VUE_APP_BASEURL + "/service-reports?type=" + a).then(
        (res) => {
          if (a === "all") {
            this.finishServiceReports = res.data.serviceReports.filter(
              (customer) => customer.line === "finish-analytics"
            );
            this.finishServiceReports = this.finishServiceReports.reduce(
              function (r, a) {
                r[a.acctmgr] = r[a.acctmgr] || [];
                r[a.acctmgr].push(a);
                return r;
              },
              Object.create(null)
            );
            this.aquaServiceReports = res.data.serviceReports.filter(
              (customer) => customer.line === "aqua-analytics"
            );
            this.aquaServiceReports = this.aquaServiceReports.reduce(function (
              r,
              a
            ) {
              r[a.acctmgr] = r[a.acctmgr] || [];
              r[a.acctmgr].push(a);
              return r;
            },
            Object.create(null));
            this.metalServiceReports = res.data.serviceReports.filter(
              (customer) => customer.line === "aqua-analytics"
            );
            this.metalServiceReports = this.metalServiceReports.reduce(
              function (r, a) {
                r[a.acctmgr] = r[a.acctmgr] || [];
                r[a.acctmgr].push(a);
                return r;
              },
              Object.create(null)
            );
          } else if (a === "finish-analytics") {
            this.finishServiceReports = res.data.serviceReports.reduce(
              function (r, a) {
                r[a.acctmgr] = r[a.acctmgr] || [];
                r[a.acctmgr].push(a);
                return r;
              },
              Object.create(null)
            );
            this.metalServiceReports = [];
            this.aquaServiceReports = [];
          } else if (a === "metal-analytics") {
            this.metalServiceReports = res.data.serviceReports.reduce(function (
              r,
              a
            ) {
              r[a.acctmgr] = r[a.acctmgr] || [];
              r[a.acctmgr].push(a);
              return r;
            },
            Object.create(null));
            this.finishServiceReports = [];
            this.aquaServiceReports = [];
          } else if (a === "aqua-analytics") {
            this.aquaServiceReports = res.data.serviceReports.reduce(function (
              r,
              a
            ) {
              r[a.acctmgr] = r[a.acctmgr] || [];
              r[a.acctmgr].push(a);
              return r;
            },
            Object.create(null));
            this.finishServiceReports = [];
            this.metalServiceReports = [];
          }
        }
      );
    },
  },
};
</script>
<style>
tr:nth-child(even) {
  background: rgb(206, 206, 206);
}
th.primary--text {
  font-size: 16px !important;
}

th.primary--text p {
  font-size: 0.9rem;
}
</style>
